export const inputStyle = {
  width: '100%',
  padding: '0.75rem 1rem',
  backgroundColor: 'var(--bg-card)',
  border: '1px solid var(--border-medium)',
  borderRadius: '8px',
  color: 'var(--text-primary)',
  fontSize: '1rem',
  fontFamily: 'inherit'
};

export const labelStyle = {
  display: 'block',
  marginBottom: '0.5rem',
  fontWeight: '600',
  color: 'var(--text-primary)',
  fontSize: '0.95rem'
};

export const helpStyle = {
  marginTop: '0.4rem',
  fontSize: '0.85rem',
  color: 'var(--text-secondary)',
  fontStyle: 'italic'
};

const GRID_SPANS = { half: 'span 6', third: 'span 4' };

export const widthStyle = (width) => ({
  gridColumn: GRID_SPANS[width] || 'span 12'
});

export const daysFromToday = (iso) => {
  if (!iso) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(`${iso}T00:00:00`);
  return Math.round((target - today) / 86400000);
};
